/**
 * Client-side preview for /admin/waitlist-email — keep placeholders in sync with
 * remix/app/lib/waitlist-email.server.js (applyWaitlistPlaceholders).
 */

function htmlEscape(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export const WAITLIST_PREVIEW_SAMPLE = {
  email: "merchant@example.com",
  variant: "intelligence",
  useCase: "Track competitor Meta ads",
};

export function applyWaitlistPreviewPlaceholders(subject, htmlBody, sample) {
  const s = sample || WAITLIST_PREVIEW_SAMPLE;
  const safeEmail = htmlEscape(s.email);
  const safeVariant = htmlEscape(s.variant);
  const safeUse =
    s.useCase && String(s.useCase).trim()
      ? htmlEscape(String(s.useCase).trim())
      : "—";

  const run = (str) =>
    String(str)
      .replaceAll("{{email}}", safeEmail)
      .replaceAll("{{variant}}", safeVariant)
      .replaceAll("{{useCase}}", safeUse);

  return { subject: run(subject), htmlBody: run(htmlBody) };
}
